import background1 from "../assets/image/background/background1.webp";
import background2 from "../assets/image/background/background2.webp";
import background3 from "../assets/image/background/background3.webp";
import background4 from "../assets/image/background/background4.webp";
import background5 from "../assets/image/background/background5.webp";
import logo from "../assets/image/logo.png";
import error from "../assets/image/errors.svg";
import header_bg from "../assets/image/engine/header_bg.jpg";

import user from "../assets/icons/user.png";
import lunch from "../assets/icons/lunch.png";
import dinner from "../assets/icons/dinner.png";
import breakfast from "../assets/icons/breakfast.png";

import imagePlaceholder from "../assets/image/placeholders/imagePlaceholder.jpg";
import bdePlaceholder from "../assets/image/placeholders/bdePlaceholder.png";
import profilePlaceholder from "../assets/image/placeholders/profilePlaceholder.png";
import vendorPlaceholder from "../assets/image/placeholders/vendorPlaceholder.png";

import fevicon from "../assets/image/fevicon.png";

import notification from "../assets/audio/notification.mp3";
export const notification_sound = notification;

// Export the backgrounds and logo
const assets = {
  backgrounds: [
    background1,
    background2,
    background3,
    background4,
    background5,
  ],
  logo,
  error,
  header_bg,
  user,
  lunch,
  dinner,
  breakfast,
  imagePlaceholder,
  bdePlaceholder,
  profilePlaceholder,
  vendorPlaceholder,
  fevicon,
};

export default assets;
